import * as React from 'react';
import styles from './Content.module.css';

const Face = () => {
  const [mousePos, setMousePos] = React.useState({ x: 0, y: 0 });
  const [isHovering, setIsHovering] = React.useState(false);
  const [themeMode, setThemeMode] = React.useState(0); // 0: Default Blue, 1: White, 2: Pink

  const handleMouseMove = (e) => {
    setMousePos({ x: e.clientX, y: e.clientY });
  };

  const toggleTheme = () => {
    const nextMode = (themeMode + 1) % 3;
    setThemeMode(nextMode);
    document.body.classList.remove('white-theme', 'pink-theme', 'light-theme');
    if (nextMode === 1) document.body.classList.add('white-theme');
    if (nextMode === 2) document.body.classList.add('pink-theme');
  };

  return (
    <main className={styles.printPage}>
      <button className="theme-toggle" onClick={toggleTheme} aria-label="Toggle Theme">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 3c-4.97 0-9 4.03-9 9s4.03 9 9 9c.83 0 1.5-.67 1.5-1.5 0-.39-.15-.74-.39-1.01-.23-.26-.38-.61-.38-.99 0-.83.67-1.5 1.5-1.5H16c2.76 0 5-2.24 5-5 0-4.42-4.03-8-9-8zm-5.5 9c-.83 0-1.5-.67-1.5-1.5S5.67 9 6.5 9 8 9.67 8 10.5 7.33 12 6.5 12zm3-4c-.83 0-1.5-.67-1.5-1.5S8.67 5 9.5 5s1.5.67 1.5 1.5S10.33 8 9.5 8zm5 0c-.83 0-1.5-.67-1.5-1.5S13.67 5 14.5 5s1.5.67 1.5 1.5S15.33 8 14.5 8zm3 4c-.83 0-1.5-.67-1.5-1.5S16.67 9 17.5 9s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z" />
        </svg>
      </button>
      <div className={styles.printContent}>
        <header>
          <div style={{ position: 'absolute', bottom: 0, left: 0 }}>
            <h1 style={{ position: 'static' }}>
              <span
                className="name-hover-container"
                onMouseEnter={() => setIsHovering(true)}
                onMouseLeave={() => setIsHovering(false)}
                onMouseMove={handleMouseMove}
              >
                Shaik Abdul Basith
                <img
                  src="/basith.png"
                  alt="Basith"
                  className="hover-image"
                  style={{
                    left: `${mousePos.x}px`,
                    top: `${mousePos.y}px`,
                    opacity: isHovering ? 1 : 0,
                  }}
                />
                <svg style={{ display: 'inline-block', width: '32px', height: '32px', verticalAlign: 'middle', marginLeft: '8px' }} fill="var(--text-color)" viewBox="0 0 24 24"><path d="M23 12l-2.44-2.79.34-3.69-3.61-.82-1.89-3.2L12 2.96 8.6 1.5 6.71 4.7l-3.61.81.34 3.7L1 12l2.44 2.79-.34 3.69 3.61.82 1.89 3.2L12 21.04l3.4 1.46 1.89-3.2 3.61-.82-.34-3.69L23 12zm-12.91 4.72l-3.8-3.81 1.48-1.48 2.32 2.33 5.85-5.87 1.48 1.48-7.33 7.35z" /></svg>
              </span>
            </h1>
            <p style={{ fontSize: '1rem', marginTop: '10px', opacity: 0.8 }}>21 Years Old | He/Him | Kurnool, Andhra Pradesh | Hyderabad, Telangana, India</p>
          </div>
        </header>

        <div className={styles.container}>
          <article>
            <ul>
              <li>
                Entrepreneur, Artist, Founder @ <a href="https://wedevit.in" target="_blank" rel="noopener noreferrer">Devit</a>, Ex-COO & Strategy Lead. GPREC ’26 | Writer | Director | Filmmaker | Content Creator | Poet | Catalyst | Believer | Designer. i make reels and post on instagram & occasionally i tweet.
              </li>
              <li>basithladoo@gmail.com</li>
              <li>
                <a
                  href="https://linkedin.com/in/basithladoo"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  linkedin.com/in/basithladoo
                </a>
              </li>
            </ul>
          </article>

          <section>
            <h2>Foundership & Projects</h2>
            <hr />
            <section>
              <article>
                <ul>
                  <li>
                    <a
                      href="https://wedevit.in"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Devit
                    </a>{' '}
                    &mdash; Founder & CEO. First in my entire bloodline to found a startup. Launched <a href="https://erusacademy.in" target="_blank" rel="noopener noreferrer">Erus Academy</a> (AI-Based English Learning App) and established a registered business while still being in college.
                  </li>
                  <li>
                    <a href="https://letsfixindia.com" target="_blank" rel="noopener noreferrer">LetsFixIndia</a> &mdash; Real-time civic issue tracker. Built with Leaflet.js, Firebase, and Mapbox to digitize civic issue reporting. Asked by Govt. of Jharkhand and Govt. of Andhra Pradesh
                  </li>
                  <li>
                    <a
                      href="https://apnenotes.co"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      ApneNotes.co
                    </a>{' '}
                    &mdash; Solving academic capitalism one note at a time.
                  </li>
                  <li>
                    <a href="https://gprec.wedevit.in" target="_blank" rel="noopener noreferrer">GPREC Central</a> &mdash; A centralized digital platform for my college peers.
                  </li>
                  <li>
                    <a href="https://hippocampos.wedevit.in" target="_blank" rel="noopener noreferrer">Hippocampos</a> &mdash; A digital personal operating system for high achievers.
                  </li>
                  <li>
                    <a href="https://www.wedevit.in/projects" target="_blank" rel="noopener noreferrer">Government ITI Monitoring</a> &mdash; Monitoring, quality-assessment, and governance platform invited for a four-Government-ITI proof of concept under the Andhra Pradesh Department of Skill Development, Employment &amp; Training.
                  </li>
                  <li>
                    <a href="https://www.wedevit.in/projects" target="_blank" rel="noopener noreferrer">Tobacco-Free Educational Institutions</a> &mdash; Compliance and evidence platform for the Andhra Pradesh Health, Medical &amp; Family Welfare Department with school self-assessment, photographic evidence, GPS checks, and offline capture.
                  </li>
                  <li>
                    <a href="https://www.wedevit.in/projects" target="_blank" rel="noopener noreferrer">Anganwadi Field Platform</a> &mdash; Worker-evaluation, multilingual beneficiary feedback, grievance routing, escalation, and field monitoring for the Andhra Pradesh Women Development &amp; Child Welfare Department.
                  </li>
                </ul>
              </article>
            </section>
          </section>

          <section>
            <h2>Experience</h2>
            <hr />

            <article>
              <ul className={styles.tight}>
                <li>
                  <sup>Present</sup>
                  <b><a href="https://wedevit.in" target="_blank" rel="noopener noreferrer">Devit</a></b> &mdash; <i>Founder</i> (Jul 2025 - Present · 9 mos). Kurnool, Andhra Pradesh, India. Launched AI-Based English Learning App & LetsFixIndia civic reporting platform & Devit Website.
                </li>
                <li>
                  <sup>Present</sup>
                  <b>English Club — G. Pulla Reddy Engineering College</b> &mdash; <i>SPOC and Technical Lead</i> (Dec 2023 - Present · 2 yrs 4 mos). Leading and coordinating English Club activities and tech at GPREC.
                </li>
                <li>
                  <sup>2025</sup>
                  <b><a href="https://blindersoe.com" target="_blank" rel="noopener noreferrer">Blindersoe Private Limited</a></b> &mdash; <i>Chief Operating Officer</i> (Feb 2025 - Dec 2025 · 11 mos). Strategic planning, strategy execution, and operations.
                </li>
                <li>
                  <sup>2025</sup>
                  <b><a href="https://blindersoe.com" target="_blank" rel="noopener noreferrer">Blindersoe Private Limited</a></b> &mdash; <i>Operations Manager</i> (Jul 2024 - Mar 2025 · 9 mos). Social media marketing, strategic planning, and operations.
                </li>
                <li>
                  <sup>2025</sup>
                  <b><a href="https://thewebblinders.in" target="_blank" rel="noopener noreferrer">The Web Blinders</a></b> &mdash; <i>Operations Manager</i> (Jul 2024 - Dec 2025 · 1 yr 6 mos · Part-time). Oversaw dev-to-delivery pipeline for clients in web solutions.
                </li>
                <li>
                  <sup>2025</sup>
                  <b>Samsung R&D Institute India - Bangalore</b> &mdash; <i>Artificial Intelligence Researcher</i> (Dec 2024 - Apr 2025 · 5 mos · Internship). IITDM, Kurnool. Python, NLP, and AI research.
                </li>
              </ul>
            </article>
          </section>

          <section>
            <h2>Education & Exposure</h2>
            <hr />

            <article>
              <div>
                <h3>
                  B.Tech, Computer Science (Data Science) &mdash; <br />
                  G. Pulla Reddy Engineering College, Kurnool
                </h3>
                <p className="smaller">2022 – 2026. Class of 2026.</p>
                <h3 style={{ marginTop: '20px' }}>
                  Intermediate &mdash; St. Mary's Junior College Govt AIDED
                </h3>
                <p className="smaller">Grade: 98.1 | 2020 - 2021</p>
                <h3 style={{ marginTop: '20px' }}>
                  Intermediate &mdash; Narayana Junior College, Kurnool
                </h3>
                <p className="smaller">Grade: 97.6 | 2019 - 2020</p>
                <h3 style={{ marginTop: '20px' }}>
                  School &mdash; Sri Lakshmi High School, Kurnool
                </h3>
                <p className="smaller">Grade: 9.7 | 2007 - 2019</p>
              </div>
            </article>
          </section>

          <section>
            <h2>Motto</h2>
            <hr />

            <article>
              <div>
                <p>
                  we are all going to be worm food anyways. - basith, 2024
                </p>
              </div>
            </article>
          </section>

          <footer>
            <p>☆</p>
            <p>Wanna talk? Reach out.</p>
            <ul>
              <li>
                <a href="mailto:basithladoo@gmail.com" target="_blank" rel="noopener noreferrer">Email: basithladoo@gmail.com</a>
              </li>
              <li>
                <a href="https://instagram.com/basithladdu" target="_blank" rel="noopener noreferrer">Instagram</a>
              </li>
              <li>
                <a href="https://twitter.com/basithladdu" target="_blank" rel="noopener noreferrer">Twitter</a>
              </li>
              <li>
                <a href="https://youtube.com/@basithladdu" target="_blank" rel="noopener noreferrer">YouTube</a>
              </li>
              <li>
                <a href="https://letterboxd.com/basithladoo/" target="_blank" rel="noopener noreferrer">Letterboxd</a>
              </li>
              <li>
                <a href="https://open.spotify.com/user/31kc2rvppa2sk2v63yrggc2lp7s4?si=c0e8772f810b43a4" target="_blank" rel="noopener noreferrer">Spotify</a>
              </li>
            </ul>
          </footer>
        </div>
      </div>
    </main>
  );
}

export default Face;
